import { SalesRepIntakeForm } from "@/components/sales-intake/SalesRepIntakeForm";

/** OI-5b — Dealer portal Place Order (slim bucket; reuses sales-rep form). */
export function DealerPlaceOrderPanel() {
  return (
    <div className="w-full space-y-4 text-left">
      <SalesRepIntakeForm
        showSubmissionsList={false}
        formTitle="Place Order"
        formDescription="Submit a customer order to a manufacturer you subscribe to. The order enters their intake queue for review."
      />
    </div>
  );
}
